import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=0f32c887&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"
import style0 from "./Tag.vue?vue&type=style&index=0&id=0f32c887&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32c887",
  null
  
)

export default component.exports